import {Pipe, PipeTransform} from "@angular/core";
import {Participant, ParticipantType} from "@models";
import Enumerable from "linq";

@Pipe({
	name: "filterParticipants",
	standalone: true,
})
export class FilterParticipantsPipe implements PipeTransform {
	transform(participations: Participant[], participantType: ParticipantType): Participant[] {
		participations = Enumerable.from(participations)
			.where((participation) => participation.participantType === participantType)
			.toArray();

		return participations;
	}
}
